import { ServerClient } from 'common/utils/http/http-clients';
import { IRejectRentalReservation, IRentalReservationDetailsRead, IRentalReservationRead } from './rental-reservation.service.types';

class RentalReservationService {
  async getRentalReservations(): Promise<IRentalReservationRead[]> {
    const res = await ServerClient.get<IRentalReservationRead[]>('/rental-reservations');
    return res?.data;
  }

  async getRentalReservation(reservationId: number): Promise<IRentalReservationDetailsRead> {
    const res = await ServerClient.get<IRentalReservationDetailsRead>(`/rental-reservations/${reservationId}`);
    return res?.data;
  }

  async approve(reservationId: number): Promise<void> {
    await ServerClient.post(`/rental-reservations/${reservationId}/actions/approve`);
  }

  async reject(reservationId: number, model: IRejectRentalReservation): Promise<void> {
    await ServerClient.post(`/rental-reservations/${reservationId}/actions/reject`, model);
  }
}

export const rentalReservationService = new RentalReservationService();
export default rentalReservationService;
